module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StepPage/ig_basic_display_api_allow-5dfbfa14593e90df33292c9c1fa11cb1.png";